import { autoUpdate, useFloating } from "@floating-ui/react";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

export function PulsatingBorderHighlight({ target }: { target: Element }) {
  const [box, setBox] = useState({ top: 0, left: 0, width: 0, height: 0, borderRadius: 0 });

  const floating = useFloating({
    open: !!target,
    whileElementsMounted: autoUpdate,
    elements: {
      reference: target,
    },
    transform: false,
  });

  const computedTargetPosition = { x: floating.x, y: floating.y };

  useEffect(() => {
    const box = target.getBoundingClientRect();
    const borderRadius = Number.parseFloat(getComputedStyle(target).borderRadius);

    setBox({
      top: box.top + window.scrollY,
      left: box.left + window.scrollX,
      width: box.width,
      height: box.height,
      borderRadius,
    });
  }, [computedTargetPosition.x, computedTargetPosition.y, target]);

  return (
    target &&
    createPortal(
      <div
        id="pyne-pulse-box"
        ref={(el) => {
          floating.refs.setFloating(el);
        }}
        style={{
          boxSizing: "border-box",
          margin: "0px auto",
          minWidth: "0px",
          top: "0",
          left: "0",
          transform: `translate(${roundByDPR(box.left)}px,${roundByDPR(box.top)}px)`,
          height: box.height + "px",
          width: box.width + "px",
          position: "absolute",
          cursor: "pointer",
          borderRadius: box.borderRadius + "px",
          animation: "1.8s ease 0s infinite normal none running animation-box-pulse",
          pointerEvents: "none",
        }}
      ></div>,
      document.body
    )
  );
}

function roundByDPR(value: number) {
  const dpr = window.devicePixelRatio || 1;
  return Math.round(value * dpr) / dpr;
}
